/**
 * Product card image swipe gallery (setting: card_swipe_gallery).
 *
 * Images are STACKED (absolute) and shown via opacity — no scrolling, no
 * scroll-snap, no transform strip. This makes the position deterministic:
 * the first image is shown by default and only JS changes the active one, so
 * the card can never "start" on the last image.
 *
 *   a.product-card__image--swipe
 *     > div[data-card-track]   (stacked <img>, max 4)
 *     > span[data-card-dots]   (one <span.product-card__dot> per image)
 *
 * Desktop (mouse): horizontal mouse position over the image picks the image
 *   (left=1st, right=2nd/3rd/4th); leaving returns to the 1st.
 * Mobile (touch): horizontal swipe changes image (tap still opens the product,
 *   vertical drag scrolls the page — touch-action: pan-y).
 * Images load via IntersectionObserver (independent of lazysizes/scroll).
 */
(function () {
  var canHover =
    window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function trackImgs(track) {
    return track.querySelectorAll('.product-card__track-img');
  }

  function visibleImgs(track) {
    var list = trackImgs(track);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) out.push(list[i]);
    }
    return out.length ? out : Array.prototype.slice.call(list);
  }

  function loadTrackImages(track) {
    if (track._cardLoaded) return;
    track._cardLoaded = true;
    var list = trackImgs(track);
    for (var i = 0; i < list.length; i++) {
      var im = list[i];
      // 2-4. gorseller data-card-src/srcset ile bekletiliyor; burada yukluyoruz.
      var cs = im.getAttribute('data-card-srcset');
      var cu = im.getAttribute('data-card-src');
      // Kolon sayisi degismis olabilir; gercek kart genisligini ver.
      if (cs && !im.getAttribute('srcset') && track.offsetWidth) im.setAttribute('sizes', track.offsetWidth + 'px');
      if (cs && !im.getAttribute('srcset')) im.setAttribute('srcset', cs);
      if (cu && !im.getAttribute('src')) im.setAttribute('src', cu);
    }
  }

  // Sadece MASAUSTU: gorselleri kart yaklasinca onceden yukle (hover akici olsun).
  // Mobilde scroll'da yuklenmez; ilk dokunusta yuklenir (koleksiyon hizli kalir).
  var imgObserver =
    canHover && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) {
                loadTrackImages(en.target);
                imgObserver.unobserve(en.target);
              }
            });
          },
          { rootMargin: '400px 0px' }
        )
      : null;

  // Mobil: kart viewport'tan tamamen cikinca 1. gorsele sifirla (Trendyol gibi).
  var resetObserver =
    !canHover && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting && en.target._idx) {
                showIndex(en.target, 0);
              }
            });
          },
          { threshold: 0 }
        )
      : null;

  function setActiveDot(track, idx) {
    var wrap = track.parentNode && track.parentNode.querySelector('[data-card-dots]');
    if (!wrap) return;
    var dots = wrap.children;
    for (var i = 0; i < dots.length; i++) {
      if (i === idx) dots[i].classList.add('is-active');
      else dots[i].classList.remove('is-active');
    }
  }

  function showIndex(track, i) {
    var list = trackImgs(track);
    if (i < 0) i = 0;
    if (i > list.length - 1) i = list.length - 1;
    for (var j = 0; j < list.length; j++) {
      list[j].style.opacity = j === i ? '1' : '0';
    }
    track._idx = i;
    setActiveDot(track, i);
  }

  /* ---------------- Desktop: hover position ---------------- */
  function bindHover(track) {
    var card = track.parentNode;
    if (!card) return;
    showIndex(track, 0);
    var raf = false;
    var lastX = 0;
    var lastZone = -1;

    card.addEventListener('mousemove', function (e) {
      lastX = e.clientX;
      if (raf) return;
      raf = true;
      window.requestAnimationFrame(function () {
        raf = false;
        var n = visibleImgs(track).length;
        if (n < 2) return;
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        var zone = Math.floor((lastX - rect.left) / (rect.width / n));
        if (zone < 0) zone = 0;
        if (zone > n - 1) zone = n - 1;
        if (zone === lastZone) return;
        lastZone = zone;
        showIndex(track, zone);
      });
    });

    card.addEventListener('mouseleave', function () {
      lastZone = -1;
      showIndex(track, 0);
    });
  }

  /* ---------------- Mobile: horizontal swipe ---------------- */
  function bindTouch(track) {
    var card = track.parentNode;
    if (!card) return;
    showIndex(track, 0);
    if (resetObserver) resetObserver.observe(track);
    var sx = 0, sy = 0, st = 0, active = false, swiped = false;

    card.addEventListener(
      'touchstart',
      function (e) {
        loadTrackImages(track); // ilk dokunusta 2-4. gorselleri yukle (1 kez)
        var t = e.touches && e.touches[0];
        if (!t) { active = false; return; }
        sx = t.clientX; sy = t.clientY; st = Date.now();
        active = true; swiped = false;
      },
      { passive: true }
    );

    card.addEventListener(
      'touchend',
      function (e) {
        if (!active) return;
        active = false;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy, dt = Date.now() - st;
        // Yatay baskin degilse (dikey/capraz) dokunma; sayfa kaysin.
        if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
        // Yavas >=30px ya da hizli flick >=14px/300ms.
        if (Math.abs(dx) < 30 && !(Math.abs(dx) >= 14 && dt <= 300)) return;
        var n = visibleImgs(track).length;
        if (n < 2) return;
        var cur = track._idx || 0;
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next < 0) next = 0;
        if (next > n - 1) next = n - 1;
        if (next === cur) return;
        swiped = true;
        showIndex(track, next);
      },
      { passive: true }
    );

    // Swipe yapildiysa link navigasyonunu engelle; saf tap ise gecsin.
    card.addEventListener(
      'click',
      function (e) {
        if (swiped) {
          e.preventDefault();
          e.stopPropagation();
          swiped = false;
        }
      },
      true
    );
  }

  function register(track) {
    if (track._cardReg) return;
    track._cardReg = true;
    if (canHover) {
      // Masaustu: gorselleri onceden yukle (IO yoksa direkt yukle), hover akici.
      if (imgObserver) imgObserver.observe(track);
      else loadTrackImages(track);
      bindHover(track);
    } else {
      // Mobil: scroll'da yukleme yok; ilk dokunusta yuklenir (bindTouch icinde).
      bindTouch(track);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-card-track]').forEach(register);
  }

  function boot() {
    scan(document);
    if ('MutationObserver' in window) {
      var scheduled = false;
      var mo = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          scan(document);
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
